var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3124({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    transform: "matrix(-1 0 0 1 44 0)",
    fill: "#747BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2508 27.3999L29.5508 28.0999C29.2508 28.3999 28.7508 28.3999 28.4508 28.0999L24.4508 24.0999L20.4508 28.0999C20.1508 28.3999 19.6508 28.3999 19.3508 28.0999L18.6508 27.3999C18.3508 27.0999 18.3508 26.5999 18.6508 26.2999L22.6508 22.2999L18.6508 18.2999C18.3508 17.9999 18.3508 17.4999 18.6508 17.1999L19.3508 16.4999C19.6508 16.1999 20.1508 16.1999 20.4508 16.4999L24.4508 20.4999L28.4508 16.4999C28.7508 16.1999 29.2508 16.1999 29.5508 16.4999L30.2508 17.1999C30.5508 17.4999 30.5508 17.9999 30.2508 18.2999L26.2508 22.2999L30.2508 26.2999C30.5508 26.5999 30.5508 27.0999 30.2508 27.3999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.55 11H15.65C14.75 11 14.15 11.4 13.65 12.1L7.15 21.9C6.95 22.2 6.95 22.5 7.15 22.7L13.65 32.5C14.15 33.1 14.75 33.6 15.65 33.6H34.45C35.85 33.6 36.95 32.5 36.95 31.1V13.5C37.05 12.1 35.95 11 34.55 11Z",
    stroke: "white",
    strokeWidth: 2.0101,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3124);
export default __webpack_public_path__ + "static/media/Group 3124.dd8627aa9aa37369582053e6f6202c98.svg";
export { ForwardRef as ReactComponent };